import { render, staticRenderFns } from "./RoundItem.vue?vue&type=template&id=3530e319&scoped=true&"
import script from "./RoundItem.vue?vue&type=script&lang=js&"
export * from "./RoundItem.vue?vue&type=script&lang=js&"
import style0 from "./RoundItem.vue?vue&type=style&index=0&id=3530e319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530e319",
  null
  
)

export default component.exports